var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 10H12.5013M7.5013 13.3333H12.5013M14.168 17.5H5.83464C4.91416 17.5 4.16797 16.7538 4.16797 15.8333V4.16667C4.16797 3.24619 4.91416 2.5 5.83464 2.5H10.4895C10.7105 2.5 10.9224 2.5878 11.0787 2.74408L15.5906 7.25592C15.7468 7.4122 15.8346 7.62416 15.8346 7.84518V15.8333C15.8346 16.7538 15.0884 17.5 14.168 17.5Z",
    stroke: "#535964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleIcon);
export default __webpack_public_path__ + "static/media/SingleIcon.bf5c7fb6c2ca4d62b4bcc689cc4ed222.svg";
export { ForwardRef as ReactComponent };